module.exports = __webpack_public_path__ + "img/business-profile-active.979e3fda.svg";